// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Explore{\n  --tw-text-opacity:1 !important;\n  color:rgba(255, 255, 255, var(--tw-text-opacity)) !important\n}\n.Routes{\n  --tw-text-opacity:1 !important;\n  color:rgba(31, 42, 68, var(--tw-text-opacity)) !important\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
